import React from 'react'

const Modal = ({ displayModal, content, closeModal, typeModal }) => {

    const divStyle = {
        display: displayModal ? 'block' : 'none'
    };
    const close = (e) => {
        e.stopPropagation()
        closeModal(e)
    }

    return (
        <div
            className={"modal " + typeModal}
            onClick={close}
            style={divStyle} >
            <div
                className={`modal-content ${typeModal && 'content-' + typeModal}`}
                onClick={e => e.stopPropagation()} >
                {content}
            </div>
        </div>
    );
}
export default Modal;